import React from 'react'
import {Table, TableBody, TableHead, TableRow, withStyles} from '@material-ui/core';
import styles from '../styles'
import {withTranslation} from 'react-i18next';
import {compose} from 'recompose';
import PropTypes from 'prop-types';
import classNames from 'classnames'
import {Pagination, Portlet, PortletContent, TableCellWithConfig, TableSettings, TextPlaceholderWrapper} from '../..'
import {displayModes} from '../../../services/enums/displayModes';
import useTablePagination from '../../../hooks/useTablePagination';
import useTableConfig from '../../../hooks/useTableConfig';
import DefaultConfig from './config';
import {getTableKey} from '../../../services/util/tableConfigHelper';
import {TableKind} from '../../../services/enums/TableKind';
import Columns from './columns';

function InvoiceTable(props) {

  const {
    classes,
    className,
    invoices,
    t,
    tableDisplayMode,
  } = props;

  const {
    config,
    columnConfigs,
    updateConfig
  } = useTableConfig(
    DefaultConfig,
    tableDisplayMode,
    getTableKey(TableKind.InvoiceTable, tableDisplayMode),
  )

  const {paginationProps, pagedObjects} = useTablePagination(invoices);

  const rootClassName = classNames(classes.root, className);

  return (
    <TextPlaceholderWrapper
      active={!invoices?.length}
      text={t('noStatisticsAvailable')}
    >
      <Portlet className={rootClassName}>
        <PortletContent noPadding>
          <TableSettings
            updateConfig={updateConfig}
            tableConfig={config}
            columns={Columns}
          />
          <Table size="medium">
            <TableHead>
              <TableRow>
                {columnConfigs.map(columnConfig => (
                  <TableCellWithConfig
                    key={columnConfig.order}
                    config={columnConfig}
                  >
                    {Columns[columnConfig.columnName].header({t})}
                  </TableCellWithConfig>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {pagedObjects.map(invoice => (
                <TableRow
                  className={classNames(classes.tableRow, 'cursorPointer')}
                  key={invoice.tourStopId}
                >
                  {columnConfigs.map(columnConfig => (
                    <TableCellWithConfig
                      key={columnConfig.order}
                      config={columnConfig}
                      className={classes.tableCell}
                    >
                      {Columns[columnConfig.columnName].body({
                        invoice, classes
                      })}
                    </TableCellWithConfig>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Pagination paginationProps={paginationProps}/>
        </PortletContent>
      </Portlet>
    </TextPlaceholderWrapper>
  );
}


InvoiceTable.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  invoices: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
  tableDisplayMode: PropTypes.oneOf(Object.values(displayModes)).isRequired,
};

InvoiceTable.defaultProps = {
  tours: [],
};


export default compose(withStyles(styles), withTranslation())(InvoiceTable);
